var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.454 1.7a.6.6 0 011.092 0l1.38 3.034a1.2 1.2 0 00.966.696l3.378.357a.6.6 0 01.338 1.042l-2.518 2.27a1.2 1.2 0 00-.37 1.14l.703 3.316a.6.6 0 01-.887.645L8.6 12.506a1.2 1.2 0 00-1.2 0L4.464 14.2a.6.6 0 01-.887-.645l.703-3.316a1.2 1.2 0 00-.37-1.14L1.39 6.829a.6.6 0 01.34-1.042l3.377-.357a1.2 1.2 0 00.966-.696L7.454 1.7z",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/star-gray.aa44b83a.svg";
export { SvgStarGray as ReactComponent };